module.exports = __webpack_public_path__ + "img/pay_line.8b1511ff.png";